var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"onRowClicked":_vm.onRowClicked,"navigationPath":"onRowClicked","navigationField":"onRowClicked","beforeSetupGrid":_vm.beforeSetupGrid,"actions":_vm.actions,"expandedOptions":{
        enabled: true,
        allowExpandingAll: true,
        template: 'tip-details',
    },"summaryOptions":{
        enabled: true,
        columns: ['totalAmount'],
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }